module.exports = __webpack_public_path__ + "img/logo.7bdb5c47.svg";